import { ReactNode } from 'react';

import { Stack, SxProps, Typography } from '@mui/material';
import { Grid } from '@mui/material';

import { primaryColors } from '~components/theme/styles/colors';
import { getAssetConfig } from '~config/protocol';
import { AllVestaAssets, ELPType } from '~config/types';

import { AssetIcon } from '../assets';

export const AssetTitle = ({
  asset,
  active,
  hideTitle,
  sx,
  reverse,
  subtitle,
  containerSx,
  secondary,
  gradientBg,
  customTitle,
}: {
  asset: AllVestaAssets;
  active?: boolean;
  hideTitle?: boolean;
  sx?: SxProps;
  containerSx?: SxProps;
  secondary?: boolean;
  reverse?: boolean;
  customTitle?: ReactNode;
  gradientBg?: boolean;
  subtitle?: string;
}) => {
  let icons = null;

  if (Object.values<string>(ELPType).includes(asset)) {
    const { tokenComposition, styles } = getAssetConfig(asset as ELPType);

    if (tokenComposition && !styles.iconSrc) {
      icons = tokenComposition.map(singleAsset => {
        // need to add placeholder asset if missing
        // cfg now requires style
        return <AssetIcon key={singleAsset} asset={singleAsset} fullGradient={active && !gradientBg} />;
        // else return <CircleWavyWarning size={16} color="#b3b4c1" weight="bold" />;
      });
    } else {
      icons = <AssetIcon key={asset} asset={asset} fullGradient={active && !gradientBg} />;
    }
  } else {
    icons = <AssetIcon key={asset} asset={asset} fullGradient={active && !gradientBg} />;
  }

  const content = [
    !hideTitle ? (
      <Stack sx={sx} key={`${asset}1`}>
        <Typography
          variant={secondary ? 'h6' : 'h5'}
          color={gradientBg ? primaryColors[900] : primaryColors[100]}
        >
          {customTitle ? customTitle : asset}
        </Typography>
        {subtitle ? (
          <Typography variant={'label3'} color={primaryColors[400]}>
            {subtitle}
          </Typography>
        ) : null}
      </Stack>
    ) : null,
    <Grid
      key={`${asset}2`}
      sx={{
        mr: reverse ? '18px' : (sx as any)?.p ?? 0,
        ml: reverse ? '24px' : (sx as any)?.p ?? 0,
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        ...sx,
      }}
    >
      {icons}
    </Grid>,
  ];

  return (
    <Grid
      container
      sx={{
        ...containerSx,
        background: gradientBg ? getAssetConfig(asset).styles.gradient : '#00000000',
        justifyContent: reverse ? 'start' : 'space-between',
        alignItems: 'center',
      }}
    >
      {reverse ? content.reverse() : content}
    </Grid>
  );
};
